/**
 * fbq = facebook pixel stuff (https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking#standard-events)
 * At time of writing this comment, facebook pixel is loaded via google tag manager (search for "googletagmanager" in code)
 */
export default function fbq(...args) {
  if (window.fbq) {
    return window.fbq(...args)
  }
}
